<template>
  <div>
    <header>
      <div class="flex_r">
        <div class="ava">
          <img :src="isMy ? myUserInfo.logo : userInfo.logo" alt="" />
        </div>
        <div class="flex_c_start marginl20 flex1">
          <p class="name f24 line32 fw600">
            {{ isMy ? myUserInfo.name : userInfo.name }}
            <router-link to="/myedit" v-if="isMy" class="edit"
              >编辑资料</router-link
            >
             <span @click="changePwd"  v-if="isMy" class="changePwd edit"
              >修改密码</span
            >
            <span @click="exit" class="f16   marginl12 exit">退出</span>
          </p>
          <p class="f16 line22">{{ isMy ? myUserInfo.note : userInfo.note }}</p>
        </div>

        <div class="flex_r actions">
          <div @click="onThumbs" v-if="!isMy" class="likes cursor">
            {{ userInfo.is_praise > 0 ? "已赞" : "点赞" }}
          </div>
          <div
            @click="onHomeFollow"
            v-if="!isMy"
            class="follow cursor marginl20"
          >
            {{ userInfo.is_follow > 0 ? "取消关注" : "关注" }}
          </div>
          <div
            v-if="isMy"
            @click="showRecharge = !showRecharge"
            class="coin marginl20"
          >
            金币充值
          </div>
        </div>

        <div class="info flex_r">
          <div v-if="isMy">
            <p class="num">{{ userInfo.coins }}</p>
            <p class="subtitle">我的金币</p>
          </div>
          <div>
            <p class="num">{{ userInfo.dz }}</p>
            <p class="subtitle">{{ isMy ? "我的点赞" : "为TA点赞" }}</p>
          </div>
          <div>
            <p class="num">{{ userInfo.fs }}</p>
            <p class="subtitle">{{ isMy ? "我的粉丝" : "TA的粉丝" }}</p>
          </div>
        </div>
      </div>
    </header>

    <div v-if="isMy" class="myClass flex_r margint20">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        @click="setView(index)"
        :class="tab == index && 'active'"
        class="myClassTag"
      >
        {{ item.name }}
      </div>
    </div>

    <main class="margint20 flex_r_start">
      <div v-show="tab == 1" class="sidebar f20">
        <div
          v-for="(v, k) in mySaveDoc"
          @click="chanegSaveDoc(v.id)"
          :class="[save_doc_id == v.id && 'active']"
          :key="k"
          class="flex_r_between"
        >
          <span>{{ v.name }}</span>
          <span @click="changeDoc(v.id)" v-if="k > 0" class="fgray edit f16"
            >编辑</span
          >
        </div>
        <div @click="createFav" class="flex_r">
          <svgIcon class="add" name="add" />
          <span class="marginl4">新建收藏夹</span>
        </div>
      </div>
      <div v-show="tab == 2" class="sidebar f20">
        <div
          @click="changeFollowDoc(v.id)"
          v-for="(v, k) in myFollowDoc"
          :class="[v.id == sdid && 'active']"
          :key="k"
          class="flex_r_between"
        >
          <span>{{ v.name }}</span>
          <span
            @click.stop="changeDoc(v.id)"
            v-if="k > 0"
            class="fgray edit f16"
            >编辑</span
          >
        </div>
        <div @click="createFav" class="flex_r">
          <svgIcon class="add" name="add" />
          <span class="marginl4">新建关注</span>
        </div>
      </div>
      <div class="flex1">
        <div v-show="tab < 2 || tab == 3" class="flex_r tagList">
          <div class="fw600 type f20 line28">类型</div>
          <div
            @click="setType(index)"
            v-for="(item, index) in typeArr"
            :key="index"
            :class="[index == type && 'active']"
            class="tag"
          >
            {{ item }}
          </div>
        </div>
        <div v-show="tab < 2 || tab == 3" class="margint20">
          <myVideo
            :videoArr="videoArr"
            @onSave="onSave"
            :cancelSave="isMy && tab == 1"
            :self="isMy && tab == 0"
          />
        </div>
        <div v-show="tab == 2" class="followList">
          <div
            v-for="(item, index) in followList"
            :key="index"
            class="followItem flex_r"
          >
            <img :src="item.logo" class="flex0" alt="" />
            <div class="msg flex1">
              <p
                @click="goFollower(item.is_follow)"
                class="name fw600 cursor f20 line28"
              >
                {{ item.name }}
              </p>
              <p class="signle margint6 f16 line22">{{ item.note }}</p>
            </div>
            <div
              @click="onFollow(item.is_follow, item.sdid)"
              class="follow f16 flex0"
            >
              已关注
            </div>
          </div>
        </div>
        <hisVideo :hisArr="hisList" v-show="tab == 4" />
        <echoGroup
          @del="delEcho"
          :showDel="true"
          :echoArr="echoList"
          v-show="tab == 5"
        />
        <replyGroup :replyArr="replyList" @del="del" v-show="tab == 6" />
        <myPagination
          @prevClick="prevClick"
          @nextClick="nextClick"
          @currentChange="currentChange"
          :page_count="currengPage"
        />
      </div>
    </main>

    <div v-show="showRecharge" class="mask flex_c_center">
      <div class="content">
        <p class="close">
          <span @click.stop="showRecharge = !showRecharge">
            <svg-icon name="close" />
          </span>
        </p>
        <p class="fw600 f24 line32 t_c">扫描对应二维码进行充值</p>
        <div class="pt40 flex_r_center pay">
          <div class="wx">
            <img :src="wx" alt="微信收款码" />
            <p class="f20 fw600 line28 margint12">微信支付</p>
          </div>
          <div class="zfb">
            <img :src="zfb" alt="支付宝收款码" />
            <p class="f20 fw600 line28 margint12">支付宝</p>
          </div>
        </div>
        <div class="fgray f16 line22 pt40 t_c">
          1元=1金币，扫码充值后预计24小时内到账请耐心等待
        </div>
      </div>
    </div>

    <div v-show="showFollow" class="mask flex_c_center">
      <div class="content flex_c_start">
        <el-radio
          v-model="check"
          v-for="(item, index) in currentDoc"
          :key="index"
          :label="item.id"
          border
          >{{ item.name }}</el-radio
        >
        <div class="margint10">
          <el-input
            v-model="input"
            maxlength="10"
            @input="changeInput"
            placeholder="添加到新的列表"
          ></el-input>
        </div>

        <div class="margint20 btn">
          <el-button size="medium" @click.native="setDoc" type="primary"
            >确定</el-button
          >
        </div>
      </div>
      <div @click.stop="showFollow = !showFollow" class="close margint40">
        <svgIcon class="f40" name="close" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import hisVideo from "@/components/hisVideo";
export default {
  name: "myIndex",
  props: ["uid"],
  components: { hisVideo },
  computed: {
    ...mapState({
      zfb: (state) => state.config.jb_qr_zfb,
      wx: (state) => state.config.jb_qr_wx,
      myUserInfo: (state) => state.userInfo,
    }),
    isMy() {
      return this.uid == this.cuid;
    },
    currengPage() {
      if (this.tab == 2) return this.followPage;
      if (this.tab == 4) return this.hisPage;
      if (this.tab == 5) return this.echoPage;
      if (this.tab == 6) return this.commentPage;
      return this.page_count;
    },
  },
  data() {
    return {
      typeArr: ["不限", "视频", "音频", "文稿"],
      type: 0,
      tabList: [
        { name: "我的发布", id: 0 },
        { name: "我的收藏", id: 1 },
        { name: "我的关注", id: 2 },
        { name: "我的下载", id: 3 },
        { name: "观看历史", id: 4 },
        { name: "我的帖子", id: 5 },
        { name: "我的评论", id: 6 },
      ],
      showRecharge: false,
      userInfo: {},
      cuid: "",
      tab: 0,
      paeg: 1,
      kw: "",
      videoArr: [],
      page_count: 1,
      followList: [],
      hisList: [],
      echoList: [],
      replyList: [],
      save_uid: 0,
      save_doc_id: 0,
      download_uid: 0,
      sdid: 0,
      mySaveDoc: [],
      myFollowDoc: [],
      hisPage: 1,
      followPage: 1,
      echoPage: 1,
      commentPage: 1,
      currentDoc: [],
      showFollow: false,
      check: 0,
      input: "",
    };
  },
  watch: {
    $route(newv) {
      if (newv) {
        this.tab = 0;
        let cuid = this.$getCookie('cy_uid');
        if (!this.uid) return this.$router.push("/");
        this.cuid = cuid;
        if (cuid == this.uid) {
          this.getUserInfo().then((data) => {
            this.userInfo = data;
          });
        } else {
          this.getData();
          this.getCurrentFollowDoc();
        }
        this.getMy();
        this.getMyHis();
      }
    },
  },
  mounted() {
    let cuid = this.$getCookie('cy_uid');
    if (!this.uid) return this.$router.push("/");
    this.cuid = cuid;
    if (cuid == this.uid) {
      this.getUserInfo().then((data) => {
        this.userInfo = data;
      });
    } else {
      this.getData();
      this.getCurrentFollowDoc();
    }
    this.getMy();
    this.getMyHis();
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    ...mapMutations(['setData']),
    changeInput() {
      this.check = -1;
    },
    changePwd(){
      this.$showLogin();
    },
    exit(){
      this.$delCookie('cy_uid');
      this.$delCookie('cy_name');
      this.$delCookie('cy_logo');
      this.setData({
          key: 'userInfo',
          val: {},
      })
      this.$router.replace('/')
    },
    async getCurrentFollowDoc() {
      let data = await this.$http.get(this.$api.getFollowDoc, {
        params: { uid: this.cuid },
      });
      this.currentDoc = data.data;
    },
    async setDoc() {
      if (this.check > -1) {
        let data = await this.$http.get(this.$api.setFollow, {
          params: {
            uid: this.cuid,
            id: this.uid,
            sdid: this.check, //文件夹id
          },
        });
        this.getData();
        this.$message.success(data.msg);
      } else {
        if (!this.input && this.input != 0)
          return this.$alert("请选择添加列表");
        this.$http
          .get(this.$api["createFollowDoc"], {
            params: {
              uid: this.cuid,
              name: this.input,
            },
          })
          .then(async (res) => {
            let data = await this.$http.get(this.$api.setFollow, {
              params: {
                uid: this.cuid,
                id: this.uid,
                sdid: res.data, //文件夹id
              },
            });
            this.$message.success(data.msg);
            this.getData();
          });
      }

      this.showFollow = !this.showFollow;
    },
    goFollower(uid) {
      this.$router.replace({
        name: "myindex",
        params: {
          uid,
        },
      });
      return;
    },
    async onSave(id) {
      let data = await this.$http.get(this.$api.setSave, {
        params: {
          uid: this.cuid,
          id,
          sdid: this.sdid, //文件夹id
        },
      });
      this.getMy();

      this.$message.success(data.msg);
    },
    chanegSaveDoc(id) {
      if (this.save_doc_id == id) return;
      this.save_doc_id = id;
      this.getMy();
    },
    changeFollowDoc(id) {
      if (this.sdid == id) return;
      this.sdid = id;
      this.getMyFollow();
    },
    del(index) {
      this.replyList.splice(index, 1);
    },
    delEcho(index) {
      this.echoList.splice(index, 1);
    },
    createFav() {
      this.$msgbox
        .prompt("请输入名称", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValidator: (v) => {
            return v.length < 10;
          },
          inputErrorMessage: "长度10字以内",
        })
        .then(({ value }) => {
          if (value.length == 0 || value.length > 10) return;
          let url = this.tab == 1 ? "createSaveDoc" : "createFollowDoc";
          this.$http
            .get(this.$api[url], {
              params: {
                uid: this.cuid,
                name: value,
              },
            })
            .then((res) => {
              if (this.tab == 1) {
                this.getSaveDoc();
              }
              if (this.tab == 2) {
                this.getFollowDoc();
              }
              this.$message.success(res.msg);
            });
        })
        .catch(() => {});
    },
    async getSaveDoc() {
      let data = await this.$http.get(this.$api.getSaveDoc, {
        params: { uid: this.cuid },
      });
      this.mySaveDoc = data.data;
    },
    async getFollowDoc() {
      let data = await this.$http.get(this.$api.getFollowDoc, {
        params: { uid: this.cuid },
      });
      this.myFollowDoc = data.data;
    },
    changeDoc(id) {
      this.$alert("删除还是编辑文件名", {
        showClose: true,
        showCancelButton: true,
        cancelButtonText: "删除",
        confirmButtonText: "编辑",
        callback: async (action, instance) => {
          if (action == "confirm") {
            this.setDocName(id);
          } else if (action == "cancel") {
            this.delDoc(id);
          }
        },
      });
    },
    setDocName(id) {
      this.$msgbox
        .prompt("请输入名称", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValidator: (v) => {
            return v.length < 10;
          },
          inputErrorMessage: "长度10字以内",
        })
        .then(({ value }) => {
          if (value.length == 0 || value.length > 10) return;
          this.editDoc(id, value);
        })
        .catch(() => {});
    },
    async editDoc(id, name) {
      let data = await this.$http.get(this.$api.editDoc, {
        params: { uid: this.cuid, id, name },
      });
      if (this.tab == 1) {
        this.getSaveDoc();
      }
      if (this.tab == 2) {
        this.getFollowDoc();
      }
      this.$message.success(data.msg);
    },
    async delDoc(id) {
      let data = await this.$http.get(this.$api.delDoc, {
        params: { uid: this.cuid, id },
      });
      if (this.tab == 1) {
        this.getSaveDoc();
      }
      if (this.tab == 2) {
        this.getFollowDoc();
      }
      if (this.sdid == id) {
        // 关注
        this.sdid = 0;
        this.getMyFollow();
      }
      if (this.save_doc_id == id) {
        //收藏
        this.save_doc_id = 0;
        this.getMy();
      }
      this.$message.success(data.msg);
    },
    prevClick() {
      if (this.page > 1) {
        this.page -= 1;
        this.setView(this.tab, "pagination");
      }
    },
    nextClick() {
      if (this.page < this.page_count) {
        this.page += 1;
        this.setView(this.tab, "pagination");
      }
    },
    currentChange(v) {
      this.page = v;
      this.setView(this.tab, "pagination");
    },
    async onThumbs() {
      if (!this.$isLogin()) return;
      let data = await this.$http.get(this.$api.setPraise, {
        params: {
          uid: this.cuid,
          id: this.uid,
          type: 1,
        },
      });
      this.$message.success(data.msg);
      this.getData();
    },
    setType(inx) {
      if (inx == this.type) return;
      this.type = inx;
      this.getMy();
    },
    async onHomeFollow() {
      if (!this.$isLogin()) return;
      if (this.userInfo.is_follow > 0) {
        let data = await this.$http.get(this.$api.setFollow, {
          params: {
            uid: this.cuid,
            id: this.uid,
            sdid: this.userInfo.is_follow, //文件夹id
          },
        });
        this.$message.success(data.msg);
      } else {
        this.showFollow = !this.showFollow;
      }

      this.getData();
    },
    async onFollow(id, sdid) {
      if (!this.$isLogin()) return;
      let data = await this.$http.get(this.$api.setFollow, {
        params: {
          uid: this.cuid,
          id,
          sdid, //文件夹id
        },
      });
      this.$message.success(data.msg);
      this.getMyFollow();
    },
    async getData() {
      let data = await this.$http.get(
        this.$api.getUserInfo + "?uid=" + this.uid + "&thisuid=" + this.cuid
      );
      this.userInfo = data.data;
    },
    setView(tab, type) {
      if (!type) {
        if (tab == this.tab) return;
        this.tab = tab;
        this.page = 1;
        this.sdid = 0;
        this.download_uid = 0;
        this.save_doc_id = 0;
        this.save_uid = 0;
      }
      switch (tab) {
        case 0: {
          this.getMy();
          break;
        }
        case 1: {
          this.getSaveDoc();
          this.getMy();
          break;
        }
        case 2: {
          //我的关注
          this.getFollowDoc();
          this.getMyFollow();
          break;
        }
        case 3: {
          this.getMy();
          break;
        }
        case 4: {
          //观看历史
          this.getMyHis();
        }
        case 5: {
          //我的帖子
          this.getEcho();
          break;
        }
        case 6: {
          //我的评论
          this.getReply();
          break;
        }
        default: {
          break;
        }
      }
    },
    async getMy() {
      let obj = {
        uid: this.uid,
      };
      if (this.tab == 1) {
        obj = {
          save_uid: this.uid,
          save_doc_id: this.save_doc_id,
        };
      }
      if (this.tab == 3) {
        obj = {
          download_uid: this.uid,
        };
      }
      let { data } = await this.$http(this.$api.daList, {
        params: {
          page: this.page,
          kw: this.kw,
          type: this.type,
          topic: "0",
          job: "0",
          sex: "0",
          province: "0",
          city: "0",
          sort: "0",
          ...obj,
        },
      });
      this.videoArr = data.list;
      this.page_count = data.page_count;
    },
    async getMyFollow() {
      let { data } = await this.$http(this.$api.myFollow, {
        params: {
          uid: this.uid,
          sdid: this.sdid,
          page: this.page,
        },
      });
      this.followList = data.list;
      this.followPage = data.page_count;
    },
    async getMyHis() {
      let { data } = await this.$http(this.$api.log, {
        params: {
          uid: this.uid,
          page: this.page,
        },
      });
      this.hisList = data.list;
      this.hisPage = data.page_count;
    },
    async getEcho() {
      let { data } = await this.$http(this.$api.tzList, {
        params: {
          uid: this.uid,
          page: this.page,
          kw: "",
        },
      });
      this.echoList = data.list;
      this.echoPage = data.page_count;
    },
    async getReply() {
      let { data } = await this.$http(this.$api.replayList, {
        params: {
          uid: this.uid,
          page: this.page,
          kw: "",
        },
      });
      this.replyList = data.list;
      this.commentPage = data.page_count;
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  padding: 30px 50px;
  background: white;
  /deep/ .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0;
    margin-top: 10px;
  }
}
header {
  width: 1200px;
  color: white;
  padding: 108px 32px 32px;
  box-sizing: border-box;
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.4) 100%
    ),
    url("../../../assets/img/bg.jpg") left top / 100% 100% no-repeat;
  .ava {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .edit {
    display: inline-block;
    padding: 0 6px;
    font-size: 16px;
    height: 24px;
    line-height: 24px;
    color: white;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    margin-left: 8px;
  }
  .changePwd{
    cursor: pointer;
  }
  .exit{
    cursor: pointer;
    margin-left: 20px;
    color: rgba(255, 255, 255, 0.5);
  }
  .actions {
    font-size: 16px;
    margin-right: 32px;
    & > div {
      height: 36px;
      padding: 0 20px;
      line-height: 36px;
      text-align: center;
      color: white;
      background: #ad2729;
    }
  }
  .info {
    & > div {
      padding: 0 20px;
    }
    .num {
      font-size: 24px;
      line-height: 32px;
      text-align: center;
    }
  }
}
.myClass {
  width: 1184px;
  height: 72px;
  border-bottom: 2px solid #fafafa;
  box-sizing: border-box;
  .myClassTag {
    font-size: 20px;
    width: 120px;
    line-height: 72px;
    text-align: center;
    height: 100%;
    border-bottom: 4px solid transparent;
    &.active {
      color: #ad2729;
      border-bottom: 4px solid #ad2729;
    }
  }
}
main {
  width: 1184px;
}
.tagList {
  width: 100%;
  height: 92px;
  background: #fafafa;
  padding: 32px;
  box-sizing: border-box;
  .type {
    margin-right: 28px;
  }
  .tag {
    font-size: 16px;
    line-height: 24px;
    padding: 0 8px;
    color: #574b4b;
    margin-left: 16px;
    cursor: pointer;
    &.active {
      color: #ad2729;
    }
  }
}
.sidebar {
  div {
    width: 284px;
    height: 68px;
    line-height: 60px;
    padding: 0 20px;
    box-sizing: border-box;
    margin-right: 16px;
    &:hover {
      color: rgba(173, 39, 41, 1);
      background: rgba(173, 39, 41, 0.02);
    }
    &.active {
      color: rgba(173, 39, 41, 1);
      background: linear-gradient(
        90deg,
        rgba(214, 79, 83, 0.2) 0%,
        rgba(173, 39, 41, 0.02) 100%
      );
    }
    span.edit:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .add {
    font-size: 24px;
    color: rgba(173, 39, 41, 1);
  }
}
.followList {
  .followItem {
    width: 884px;
    height: 100px;
    box-sizing: border-box;
    border-bottom: #fafafa 2px solid;
    img {
      width: 64px;
      height: 64px;
      margin-right: 16px;
    }
    .follow {
      color: white;
      width: 88px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
      background: rgba(173, 39, 41, 0.3);
    }
    .name {
      &:hover {
        color: #ad2729;
      }
    }
  }
}
.pagination {
  span {
    display: inline-block;
    margin-right: 8px;
    font-size: 14px;
    width: 32px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    color: rgba(0, 0, 0, 0.65);
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    &.active {
      color: white;
      background: rgba(173, 39, 41, 1);
    }
  }
}
.mask {
  .content {
    width: 584px;
    padding-bottom: 40px;
    background: #ffffff;
    border-radius: 8px;
    .close {
      font-size: 36px;
      text-align: right;
      padding: 16px 16px 0 0;
    }
    .pay {
      text-align: center;
      img {
        width: 148px;
        height: 148px;
      }
      .zfb {
        margin-left: 48px;
      }
    }
  }
}
</style>